import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../utils/helpers/model.helper';

export const JOB_SCHEMA = Object.freeze({
  ID: '',
  NUMBER: null,
  CREATED_AT: '',
  PUBLIC_URL: '',
});
const RECORD = generateSchema(JOB_SCHEMA);
const KEYS: any = generateKeys(JOB_SCHEMA);

export class Job extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get number(): number {
    return this.get(KEYS.NUMBER);
  }

  get createdAt(): string {
    return this.get(KEYS.CREATED_AT);
  }

  get publicUrl(): string {
    return this.get(KEYS.PUBLIC_URL);
  }
}
